import { useMemo } from 'react';

import { useOrgTimezone } from './OrgTimezoneContext';
import { formatCalendarDate, formatInstant, todayInZone } from '@/lib/utils/date';

/**
 * Date formatters bound to the organization's timezone.
 *
 * `formatInstant` takes (iso, pattern) — the zone is already applied.
 * `formatCalendarDate` is passed through unchanged; a calendar date has no
 * zone, and that asymmetry is the point.
 */
export function useOrgDateFormat() {
  const { timeZone } = useOrgTimezone();

  return useMemo(
    () => ({
      formatCalendarDate,
      today: () => todayInZone(timeZone),
      formatInstant: (iso: string, pattern: string) => formatInstant(iso, pattern, timeZone),
    }),
    [timeZone],
  );
}
